import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    title: 'How It Works',
    subtitle: 'Get personalized recipes in three simple steps',
    step1: {
      title: 'Take a Photo',
      description: 'Snap a picture of the ingredients in your fridge or pantry'
    },
    step2: {
      title: 'AI Analysis',
      description: 'Our AI analyzes your ingredients and preferences'
    },
    step3: {
      title: 'Get Recipe',
      description: 'Receive a custom recipe tailored to your available ingredients'
    }
  },
  ar: {
    title: 'كيف يعمل',
    subtitle: 'احصل على وصفات مخصصة في ثلاث خطوات بسيطة',
    step1: {
      title: 'التقط صورة',
      description: 'التقط صورة للمكونات الموجودة في ثلاجتك أو مخزنك'
    },
    step2: {
      title: 'تحليل الذكاء الاصطناعي',
      description: 'يحلل ذكاؤنا الاصطناعي مكوناتك وتفضيلاتك'
    },
    step3: {
      title: 'احصل على الوصفة',
      description: 'احصل على وصفة مخصصة حسب المكونات المتاحة لديك'
    }
  }
};

const HowItWorks = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const steps = [
    {
      number: '1',
      title: t.step1.title,
      description: t.step1.description,
      icon: '📸'
    },
    {
      number: '2',
      title: t.step2.title,
      description: t.step2.description,
      icon: '🤖'
    },
    {
      number: '3',
      title: t.step3.title,
      description: t.step3.description,
      icon: '📋'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 px-4 bg-white" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t.title}
          </h2>
          <p className="text-xl text-gray-600">
            {t.subtitle}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-light p-8 rounded-2xl shadow-lg hover:shadow-xl transition h-full">
                <div className="text-6xl mb-6 text-center">{step.icon}</div>
                <div className="text-center mb-4">
                  <span className="inline-flex items-center justify-center w-12 h-12 bg-gradient-green text-white rounded-full font-bold text-xl">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-dark mb-4 text-center" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {step.title}
                </h3>
                <p className="text-gray-600 text-center leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a 
            href="/start"
            className="inline-block px-8 py-4 bg-gradient-green text-white rounded-lg text-lg font-semibold hover:opacity-90 transition shadow-lg"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {language === 'en' ? 'Get Started →' : 'ابدأ الآن ←'}
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;



